import React from 'react';
import { DataList, createInitialFilters } from 'commons-ui';

import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';

import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { activeFilter, columnConfigs } from './listConfig';

const PartnerCouponList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { getPartnerCouponData } = useService();
	return (
		<DataList
			fetchData={getPartnerCouponData}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={LIST_ENTITY_NAMES.PARTNER_COUPONS}
			initialFilters={createInitialFilters(activeFilter)}
			initialSortDirection='ASC'
			initialSortIndex={1}
		/>
	);
};

export default PartnerCouponList;
